import type { RailwayAuthResult, RailwayRunner } from '@cli-types/next-adapter/railway.js'
import { WHOAMI_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { parseRailwayJson } from '@next-adapter/init/railway/runner/parse-railway-json.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'
import { isRailwayAccount } from './is-railway-account.js'

export async function checkRailwayAuth(
  runner: RailwayRunner,
  cwd: string,
  env?: NodeJS.ProcessEnv
): Promise<RailwayAuthResult> {
  const result = await runRailway(runner, ['whoami', '--json'], {
    cwd,
    mode: 'capture',
    timeoutMs: WHOAMI_TIMEOUT_MS,
    env
  })

  if (!result.success) {
    return { authed: false, reason: result.timedOut ? 'timeout' : 'not-authed' }
  }

  const account = parseRailwayJson<unknown>(result.stdout)
  return isRailwayAccount(account) ? { authed: true, account } : { authed: false, reason: 'failed' }
}
